import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonConstants } from '../../constants/common.constant';
import { RecordsPerPageFilterService } from '../../services/records-per-page-filter.service';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-records-per-page-filter',
  templateUrl: './records-per-page-filter.component.html',
  styleUrls: ['./records-per-page-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatSelect, FormsModule, MatOption],
})
export class RecordsPerPageFilterComponent implements OnInit, OnDestroy {
  private recordsPerPageFilterService = inject(RecordsPerPageFilterService);

  @Output() private pageSizeChange: EventEmitter<number> = new EventEmitter<number>();

  public recordsPerPage: number;
  public recordsPerPageOptions: number[];
  private serviceSubscriptions = new Subscription();

  constructor() {
    this.recordsPerPageOptions = CommonConstants.recordsPerPageOptions;
    this.recordsPerPage = this.recordsPerPageOptions[0];
  }

  public ngOnInit(): void {
    this.serviceSubscriptions.add(this.recordsPerPageFilterService.recordsPerPage.subscribe((recordsPerPage) => (this.recordsPerPage = recordsPerPage)));
  }

  public ngOnDestroy(): void {
    this.serviceSubscriptions.unsubscribe();
  }

  public valueChange(recordsPerPage: number): void {
    this.recordsPerPageFilterService.recordsPerPage.next(recordsPerPage);
    this.pageSizeChange.emit(recordsPerPage);
  }
}
